import { useQuery } from '@tanstack/react-query';
import { client } from '../client';

function unwrapApiResponse(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) return data.data;
  return data;
}

export interface ExecutiveDashboardData {
  generatedAt: string;
  organizationId: string;
  agenda: {
    totalEvents: number;
    totalMeetings: number;
    homeOfficeCount: number;
    absencesCount: number;
    categoryBreakdown: Array<{ name: string; value: number }>;
    resourceUtilization: Array<{ name: string; quantidade: number }>;
    typeBreakdown: Array<{ name: string; total: number }>;
  };
  financial: {
    totalRevenue: number;
    totalExpenses: number;
    profit: number;
    margin: number;
    metrics: Array<{
      metric: string;
      value: number;
      calculatedAt: string;
      accountId?: string;
      costCenterId?: string;
    }>;
  };
  scores: {
    totalScores: number;
    latest: Array<{
      scoreDefId: string;
      targetType: string;
      targetId: string;
      value: number;
      ts: string;
    }>;
  };
  indicators: {
    totalIndicators: number;
    latest: Array<{
      seriesId: string;
      value: number;
      ts: string;
      meta?: any;
    }>;
  };
}

export const useExecutiveDashboard = () => {
  return useQuery({
    queryKey: ['executive-dashboard'],
    queryFn: async () => {
      const { data } = await client.get('/executive-dashboard');
      return unwrapApiResponse(data) as ExecutiveDashboardData;
    },
    staleTime: 1000 * 60 * 5,
  });
};
